/* Shared chocolate liquid. One script, any number of canvases:

   <div data-liquid>
     <canvas data-liquid-bg data-liquid-intro></canvas>
     <h1 data-liquid-carve>Colibri</h1>
   </div>

   data-liquid-bg     — required on the canvas
   data-liquid-intro  — optional idle sweep
   data-liquid-carve  — optional wordmark to engrave (inside the host)
   data-liquid-host   — optional selector for the pointer host; else [data-liquid] ancestor, else parent

   Playback is paused while the canvas is off-screen or the tab is hidden.
   WebGL is created only when a canvas first enters view.
*/
const IS_MOBILE = window.matchMedia('(pointer: coarse)').matches
  || window.matchMedia('(max-width: 991px)').matches
  || !!(navigator.connection && navigator.connection.saveData);

const CONFIG = {
  BG_DEEP:    [0.2549, 0.1216, 0.1176],
  BG_LIT:     [0.3255, 0.1569, 0.1451],
  LIGHT_DIR:  [-0.45, 0.62, 0.64],
  CONTRAST:   0.88,
  GLOSS:      0.14,
  NORMAL:     26.0,
  CARVE:      0.055,
  CARVE_BEVEL: 0.004,
  POOL:       0.35,
  AMPLITUDE:  0.34,
  RADIUS:     0.105,
  PUSH:       0.034,
  SPEED:      0.10,
  VISC:       0.105,
  DAMP:       0.994,
  MAX_STEPS:  4,
  STIFFNESS:  13.0,
  DRAG:       9.5,
  MAX_SPEED:  0.50,  
  INTRO:      true,
};


const TIERS = [
  { dpr: 1.0, sim: 0.28, carve: 1.5 },
  { dpr: 1.5, sim: 0.38, carve: 2.0 },
];

const TIERS_BG = [
  { dpr: 0.75, sim: 0.20, carve: 1.5 },
  { dpr: 1.0,  sim: 0.28, carve: 1.5 },
];

const COLIBRI_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="1852.5" height="309.72" viewBox="0 0 1852.5 309.72"><path fill="#fff" d="M568.505 0.0967898C578.193 0.229987 587.049 1.2686 594.022 3.59484C661.608 13.5791 713.811 53.0937 737.24 117.458C740.157 130.351 743.037 147.237 742.198 161.76C742.183 162.029 742.167 162.297 742.148 162.564C741.999 164.767 741.761 166.912 741.422 168.978C741.334 169.516 741.239 170.049 741.137 170.575C741.078 170.879 741.017 171.182 740.953 171.482C739.3 182.681 731.659 213.056 723.547 221.43L723.161 221.812C723.029 222.066 722.892 222.325 722.75 222.59C718.496 230.528 709.792 243.16 703.226 249.339L702.576 249.935L701.416 251.166C677.736 276.031 648.504 290.214 616.437 300.59L613.273 301.599C607.902 302.649 602.839 303.648 597.591 304.902L595.329 305.457C595.326 305.458 595.322 305.458 595.319 305.458C595.323 305.458 595.326 305.458 595.329 305.458C589.048 306.569 583.315 307.579 577.782 308.337C577.229 308.413 576.678 308.486 576.128 308.557C566.405 309.806 557.198 310.215 546.581 308.947C546.314 308.916 546.046 308.884 545.777 308.85C544.045 308.631 542.275 308.369 540.458 308.057C537.095 307.479 531.445 307.171 528.389 306.138L528.39 306.137H528.389C525.634 306.113 523.546 305.481 520.891 305.025C427.868 289.017 349.206 202.324 385.657 105.651C393.663 84.4168 405.082 70.9124 420.493 54.8966C442.497 33.4947 466.426 19.6244 495.514 10.4103C497.81 12.7489 499.635 15.1515 502.788 15.7765C471.991 23.5083 449.207 34.2505 429.15 59.9552L422.982 68.9933C365.969 175.412 484.16 302.746 592.122 295.124C598.131 294.7 604.743 295.623 610.667 294.198C610.878 294.128 611.09 294.058 611.301 293.989C648.527 286.078 670.54 272.426 693.072 242.965C735.158 175.526 697.979 90.2864 638.087 47.2579C606.922 24.8676 573.117 13.4897 536.819 13.0753C535.338 13.0584 533.852 13.0596 532.362 13.0792C523.423 13.1969 514.335 13.9716 505.101 15.4034C504.331 15.5227 503.561 15.6471 502.789 15.7755C502.691 15.756 502.593 15.7349 502.497 15.712C499.521 15.0009 497.739 12.675 495.514 10.4093C512.777 5.54705 541.146 0.240341 565.247 0.0860476C566.342 0.0790359 567.429 0.0819935 568.505 0.0967898ZM37.1788 62.0587C39.4872 62.8586 44.7693 64.4184 46.3116 65.8898C-16.1626 182.86 116.323 312.349 233.954 294.212C235.932 297.29 235.676 298.348 235.31 302.46C231.151 303.312 223.963 304.576 220.073 305.665C212.945 306.771 205.796 307.75 198.632 308.604C174.498 311.321 142.31 305.549 118.933 298.241C65.531 281.549 17.1846 240.18 3.60063 184.357C-0.646486 166.903 -1.11633 148.403 2.085 130.55C2.19171 129.955 2.30217 129.36 2.41703 128.767C5.17373 114.52 10.2779 100.723 17.6748 88.2413C18.2913 87.201 18.924 86.1701 19.5723 85.1485C21.5171 82.0843 23.605 79.1069 25.835 76.2296C26.2067 75.75 26.5824 75.2729 26.962 74.7989L27.5577 73.9181C30.5488 69.5724 33.6773 66.0949 37.1788 62.0587ZM1158.45 1.3048C1171.19 2.86883 1182.03 2.65966 1194.85 2.73644C1204.57 2.45347 1214.28 2.3814 1223.99 2.52159H1224C1253.73 2.36365 1297.74 -0.797054 1325.5 6.02355H1325.51C1330.99 6.76877 1346.8 12.721 1350.4 16.5675C1363.22 23.6695 1374.7 33.8983 1378.83 48.5489C1378.94 48.9098 1379.04 49.273 1379.12 49.6378C1381.81 56.1424 1382.06 64.3746 1380.61 72.3946C1380.59 72.5109 1380.56 72.6271 1380.54 72.7433C1380.29 74.112 1379.98 75.4734 1379.63 76.8185C1379.58 77.0059 1379.53 77.1932 1379.48 77.38C1378.18 82.2018 1376.29 86.7897 1374 90.6944C1373.78 91.0667 1373.56 91.4326 1373.34 91.7921C1372.81 92.6335 1372.26 93.4392 1371.7 94.2032C1371.67 94.239 1371.64 94.275 1371.62 94.3107C1365.44 103.092 1351.73 114.116 1341.33 116.753C1344.85 119.576 1374.3 124.011 1388.67 132.44C1384.95 132.586 1383.01 132.453 1379.66 134.111L1379.14 134.734L1379.66 134.113C1383.01 132.455 1384.95 132.587 1388.67 132.442C1411.55 145.002 1430.93 163.879 1438.37 189.536C1444.31 210.513 1441.62 232.989 1430.91 251.98C1426.5 259.89 1421.04 267.172 1414.69 273.631C1405.34 282.647 1390.96 293.277 1378.32 296.933L1378.32 296.935C1374.64 298.353 1370.8 299.768 1367.19 301.331L1367.19 301.33C1338.9 311.001 1266.81 307.534 1233.81 307.188C1208.69 306.947 1183.56 307.005 1158.43 307.361C1162.11 304.1 1166.22 300.885 1170.05 297.778C1174.4 295.17 1183.81 284.997 1187.4 281.166C1188.71 197.697 1187.62 111.234 1187.54 27.5421C1177.51 17.334 1169.32 10.6129 1158.45 1.3048ZM776.523 3.24425C777.921 2.16957 780.582 2.5811 782.746 2.56163C809.745 2.48155 836.745 2.55757 863.743 2.79015C857.603 8.08265 840.345 22.612 835.768 28.3058V28.3087C835.768 28.3074 835.768 28.3061 835.769 28.3048C836.209 32.3198 836.372 37.6747 836.412 43.2589C836.433 46.2094 836.419 49.224 836.394 52.1388C836.356 56.4978 836.294 60.6335 836.28 63.9982L836.113 124.205C836.14 172.822 837.029 224.796 836.516 274.31C836.426 282.917 836.294 291.449 836.107 299.877C836.09 300.675 836.074 301.473 836.056 302.269L904.148 302.277C915.792 302.27 931.887 302.697 943.23 301.793C943.893 301.333 944.697 300.731 945.583 300.056C946.234 299.56 946.929 299.024 947.642 298.472C950.616 296.169 953.911 293.602 955.721 292.609C975.028 277.329 993.585 259.716 1012.39 243.619C1007.48 255.718 992.067 295.269 990.499 306.169L990.378 306.237C987.648 307.639 972.773 307.119 969.332 307.115L929.345 307.211C912.219 307.242 779.792 307.875 777.238 306.068C777.247 306.032 777.258 305.996 777.268 305.96C777.893 303.527 778.719 303.481 780.975 301.568C781.03 301.527 781.085 301.484 781.142 301.442C782.415 300.497 783.829 299.364 785.309 298.124C785.695 297.8 786.086 297.469 786.481 297.132C790.82 293.428 795.572 289.032 799.083 285.928H799.084L802.591 282.609C804.019 278.168 803.259 246.217 803.23 239.129C802.94 168.556 803.896 97.917 803.157 27.3526C794.609 17.7944 785.314 12.0749 776.523 3.24425ZM1550.08 2.01671C1577.62 4.03782 1623.18 -3.03233 1647.82 8.59288C1642.74 8.66557 1642.98 7.85985 1639.46 10.3116C1639.24 11.213 1639.26 12.1196 1639.46 13.0294C1639.26 12.12 1639.24 11.2136 1639.46 10.3126C1642.98 7.86069 1642.74 8.66753 1647.82 8.59484C1693.49 24.876 1716.68 73.3103 1671.67 107.056H1671.67C1665.79 112.905 1654.57 118.728 1647.01 122.177L1629.28 130.599V130.598L1629.28 130.599V130.601C1626.32 132.547 1626.73 131.729 1625.26 134.67C1629.85 136.211 1631.39 141.5 1634.04 145.904C1660.87 190.38 1684.25 236.96 1711.14 281.387C1714.21 286.44 1730.53 301.527 1735.5 306.086L1735.27 306.942L1733.59 306.721C1715.14 307.833 1686.17 306.938 1663.86 306.84C1660.68 306.826 1657.62 306.828 1654.76 306.855C1655.18 306.513 1655.6 306.161 1656.04 305.8C1662.56 300.385 1671.1 292.905 1676.14 286.855C1672.08 280.731 1669.41 273.889 1665.9 267.508C1643.44 226.663 1619.95 186.151 1598.2 144.943L1598.2 144.942C1578.69 152.665 1552.82 167.589 1541.26 185.208C1538.45 189.486 1537 194.424 1535.17 197.279C1530.68 191.3 1530.19 196.479 1530.35 186.697H1530.35C1530.19 196.481 1530.68 191.301 1535.17 197.281C1534.54 198.747 1533.15 202.184 1532.46 203.418C1532.66 213.054 1531.88 280.556 1533.21 283.812L1533.21 283.811L1533.21 283.813C1539.79 287.809 1552.64 300.534 1560.67 306.451C1559.27 306.8 1555.56 306.956 1550.79 306.998C1549.2 307.012 1547.49 307.014 1545.7 307.006C1533.82 306.952 1518.71 306.466 1513.99 306.409C1510.36 306.399 1506.73 306.403 1503.11 306.421C1494.04 306.467 1484.97 306.602 1475.9 306.827C1474.09 306.872 1472.27 306.921 1470.46 306.973C1471.05 306.444 1471.63 305.918 1472.22 305.396C1481.02 297.563 1489.79 290.45 1498.66 282.192C1499.53 268.284 1498.93 251.596 1498.9 237.511L1498.84 167.566C1498.49 120.9 1499.28 74.0964 1499.24 27.3741C1493.31 19.9307 1478.63 8.33773 1470.94 2.12316C1475.09 2.03364 1477.98 2.12359 1482.12 2.43761C1497.27 2.46301 1513.38 2.15958 1528.4 2.48741L1529.61 3.21495H1529.61C1529.76 5.70658 1529.89 7.35555 1530.36 9.85753L1531.72 10.2589C1533.58 17.9185 1532.98 39.7623 1532.94 48.7775L1532.7 144.76C1532.69 145.524 1532.68 146.549 1532.67 147.779C1532.66 149.61 1532.64 151.893 1532.62 154.438C1532.52 166.182 1532.45 183.492 1533.2 187.584C1543.25 165.706 1572.55 150.145 1594.47 141.571L1596.57 140.764C1596.82 140.662 1597.09 140.554 1597.36 140.437C1605.87 136.804 1622.99 125.944 1629.3 120.817V120.816L1636.96 114.4C1654.05 96.7789 1664.88 78.789 1659.99 53.4698C1657.28 39.443 1647.27 25.1 1634.88 17.9083C1612.77 5.08875 1582.97 7.5685 1558.29 7.02355C1550.94 6.93363 1542.39 6.8836 1535.1 7.54699C1532.87 7.74994 1532.87 8.48905 1531.72 10.2589L1530.36 9.85656C1530.24 9.23103 1530.15 8.65878 1530.07 8.11339C1529.99 7.56803 1529.92 7.04959 1529.87 6.53136C1529.76 5.49522 1529.69 4.45948 1529.61 3.21398L1528.4 2.48644C1533.66 2.01953 1544.84 1.63138 1550.08 2.01671ZM1126.71 2.43175C1119.93 7.749 1103.52 20.7631 1097.94 26.671L1097.95 197.917C1097.91 222.584 1099.13 258.892 1097.48 282.754C1103.45 287.908 1113.01 295.694 1118.45 300.944H1118.45L1126.8 306.932L1126.79 306.931L1126.8 306.933L1068.95 306.114C1063.92 306.083 1057.42 305.92 1051.17 306.042C1051.15 306.043 1051.12 306.044 1051.09 306.044C1048.37 306.098 1045.69 306.207 1043.21 306.404C1043.15 306.409 1043.09 306.413 1043.03 306.418C1041.16 306.57 1039.41 306.774 1037.83 307.043L1037.83 307.042L1039 305.819C1043.8 300.904 1052.64 292.589 1059.41 286.879C1059.7 286.633 1059.99 286.392 1060.27 286.156C1062.16 284.589 1063.85 283.256 1065.21 282.299C1065.48 268.826 1065.67 255.214 1065.8 241.506C1066.47 170.728 1065.43 97.3894 1065.37 27.4962C1061.13 22.4214 1055.63 18.1006 1050.55 13.8234L1037.59 2.66027C1066.52 2.56286 1098.01 3.18747 1126.71 2.43175ZM1765.44 3.17296C1788.55 1.36575 1828.16 2.63341 1852.5 2.71788C1843.55 10.2143 1832.69 19.2753 1824.34 27.2823L1824.35 282.432C1833.41 290.166 1842.39 298.004 1851.28 305.941V306.806L1847.16 307.003C1818.82 306.994 1792.55 305.951 1763.65 306.339C1772.75 299.477 1782.79 288.643 1791.93 282.303C1790.75 198.036 1792.29 111.737 1791.79 27.0148C1786.57 21.2216 1771.9 8.87834 1765.44 3.17296ZM323.297 234.473C328.24 234.937 331.736 235.224 336.758 235.184C330.057 244.921 320.74 255.27 311.947 263.211V263.212C287.618 283.309 266.229 294.417 235.311 302.459C235.677 298.347 235.933 297.289 233.955 294.211C260.137 288.616 286.508 280.403 304.994 258.947L305.667 258.263C312.586 251.162 318.516 243.16 323.297 234.473ZM1224.53 6.88976C1223.12 6.79809 1221.59 6.68153 1220.33 7.32628C1221.45 9.09298 1221.43 9.51102 1221.44 11.6319C1221.39 11.7239 1221.33 11.8287 1221.28 11.9444L1221.36 11.7804C1221.39 11.7283 1221.42 11.679 1221.44 11.6329C1221.78 20.657 1221.81 29.6774 1221.78 38.7062C1221.58 85.3432 1222.14 131.999 1221.57 178.633H1221.57C1221.54 180.908 1221.26 183.125 1222.54 184.977C1222.58 184.918 1222.62 184.86 1222.66 184.802C1222.86 184.522 1223.06 184.243 1223.25 183.967C1224.1 182.795 1224.94 181.66 1225.79 180.56C1226.22 180.002 1226.66 179.454 1227.09 178.913C1242.95 159.118 1260.28 150.962 1284.3 139.573L1284.31 139.572C1298.51 132.775 1305.22 128.691 1317.8 118.912C1321.94 124.771 1322.12 123.984 1329.63 123.755C1318.04 130.692 1303.57 135.491 1291.66 141.759L1290.51 142.37C1267.06 152.833 1247.28 162.08 1233.4 180.234C1233.09 180.642 1232.78 181.056 1232.47 181.474C1230.63 183.981 1228.91 186.654 1227.29 189.52C1225.73 192.279 1224.28 195.214 1222.94 198.351L1222.94 198.35V198.352C1220.26 204.299 1221.89 267.317 1221.63 279.291L1221.67 280.883C1221.83 288.683 1221.39 294.231 1220.67 302.368C1248.4 301.222 1276.84 302.684 1304.72 302.344C1329.23 302.044 1337.6 303.465 1360.98 295.207L1360.98 295.206V295.205C1367.91 290.952 1372.2 287.349 1378.52 282.144C1425.91 237.08 1411.7 140.466 1344.38 123.052C1338.6 121.558 1334.89 120.659 1329.63 123.753C1322.12 123.982 1321.94 124.769 1317.81 118.91L1321.5 115.638C1331.34 106.127 1339.56 96.9065 1343.88 83.6202C1348.53 68.9805 1347.15 53.0927 1340.05 39.4708C1318.21 -3.21774 1263.55 9.42634 1224.53 6.88976ZM1362.87 298.416C1362.95 298.505 1363.03 298.591 1363.12 298.675C1363.03 298.591 1362.95 298.505 1362.87 298.416ZM1218.69 292.437C1218.71 292.784 1218.73 293.145 1218.76 293.52L1218.92 295.727C1218.82 294.494 1218.74 293.415 1218.69 292.436V292.437ZM310.491 262.684C310.76 262.804 311.035 262.911 311.317 263.01C311.035 262.911 310.76 262.804 310.491 262.684ZM693.094 243.838H693.095H693.094ZM1407.06 241.144C1406.4 241.874 1405.69 242.642 1404.93 243.453C1405.69 242.642 1406.4 241.874 1407.06 241.144ZM1409.72 238.115C1409.28 238.633 1408.82 239.173 1408.32 239.738C1408.82 239.174 1409.28 238.634 1409.72 238.116L1409.72 238.115ZM1411.2 236.288C1411.23 236.253 1411.26 236.219 1411.29 236.185L1411.29 236.183C1411.26 236.218 1411.23 236.253 1411.2 236.288ZM1408.23 201.627C1408.17 201.822 1408.1 202.016 1408.03 202.21C1408.1 202.016 1408.17 201.822 1408.23 201.627ZM1666.19 71.9083C1666.65 75.2261 1666.87 78.4017 1666.22 79.9259C1661.81 82.8653 1654.47 98.8386 1651.79 104.288C1651.63 104.601 1651.64 104.922 1651.72 105.245C1651.64 104.923 1651.64 104.602 1651.79 104.289C1654.47 98.8394 1661.81 82.8657 1666.22 79.9269C1666.87 78.4025 1666.65 75.2265 1666.19 71.9083ZM1219.67 76.3556C1219.6 76.5018 1219.53 76.621 1219.46 76.712C1219.44 76.6902 1219.43 76.6655 1219.42 76.6378C1219.43 76.6658 1219.44 76.691 1219.46 76.713C1219.53 76.622 1219.6 76.5028 1219.67 76.3566V76.3556ZM1219.1 75.1886C1219.14 75.5004 1219.18 75.7713 1219.23 75.9982C1219.18 75.7714 1219.14 75.5005 1219.1 75.1886ZM1219.96 75.4064C1219.9 75.6389 1219.85 75.8468 1219.79 76.0284L1219.85 75.839C1219.89 75.7062 1219.92 75.5617 1219.96 75.4064ZM1220.22 73.7247C1220.17 74.1601 1220.12 74.556 1220.05 74.9093L1220.14 74.3487C1220.17 74.1509 1220.2 73.9427 1220.22 73.7247ZM1218.43 52.4864C1218.46 61.2567 1218.58 69.2272 1218.93 73.5167C1218.58 69.2275 1218.46 61.2569 1218.43 52.4864ZM1665.02 64.6827C1665.19 65.7063 1665.39 66.8833 1665.6 68.1251C1665.39 66.8833 1665.19 65.7062 1665.02 64.6827ZM1220.57 61.0831C1220.59 63.5375 1220.59 65.8169 1220.55 67.838L1220.58 65.7345C1220.59 64.2786 1220.59 62.7202 1220.57 61.0841V61.0831ZM187.868 0.00401632C202.699 0.0974141 216.774 1.82447 228.78 5.50109C258.57 12.3397 285.094 24.3908 308.662 44.0509C315.676 49.9013 324.398 59.071 331.11 63.9903C328.437 63.8365 317.685 63.081 315.636 63.3194L314.765 63.4376C312.664 63.7002 310.087 63.8742 307.251 63.9855C306.863 64.0007 306.471 64.0145 306.074 64.0275C305.641 64.0415 305.203 64.055 304.761 64.0665C303.913 64.0886 303.049 64.1056 302.174 64.1193C301.299 64.1329 300.412 64.1422 299.52 64.1485C298.627 64.1549 297.728 64.1581 296.828 64.1583C295.928 64.1585 295.028 64.1562 294.131 64.1515C287.854 64.1184 281.77 63.9795 277.606 63.9386C272.636 59.7142 268.345 56.1553 264.449 53.0675C258.606 48.436 253.652 44.8639 248.63 41.6935C247.514 40.9889 246.394 40.3041 245.261 39.6319C244.694 39.2959 244.124 38.9635 243.549 38.6329C241.824 37.6411 240.056 36.6691 238.21 35.6935C236.979 35.043 235.713 34.3909 234.401 33.7296C229.811 31.415 224.664 28.9898 218.51 26.1446C216.752 25.3318 214.911 24.4844 212.978 23.5958L207.217 21.9425C194.449 18.2692 185.916 15.8663 171.429 14.2413C166.124 13.6462 160.763 13.3192 155.388 13.2696C154.044 13.2572 152.699 13.262 151.355 13.2843C150.01 13.3066 148.665 13.3471 147.32 13.4044C146.648 13.433 145.976 13.4656 145.304 13.503C111.034 15.4117 77.2755 28.7671 54.9414 55.6124C53.415 57.4474 48.074 64.2497 46.4571 65.7599C46.4048 65.8087 46.3567 65.8524 46.3125 65.8898C46.2644 65.8438 46.2126 65.7972 46.1573 65.7511C44.4432 64.3211 39.4161 62.8327 37.1797 62.0577C51.4171 46.1022 68.3361 32.7584 87.1719 22.6271C112.207 9.34224 149.269 0.587397 183.161 0.0284304C184.738 0.00243233 186.307 -0.00581487 187.868 0.00401632ZM1663.38 35.2179C1663.31 40.9047 1663.35 46.1711 1663.66 51.4962C1663.35 46.1714 1663.31 40.9053 1663.38 35.2189C1663.28 35.1094 1663.17 34.9993 1663.07 34.8888L1663.07 34.8878C1663.17 34.9983 1663.28 35.1084 1663.38 35.2179ZM1220.14 39.4171C1220.2 42.6245 1220.28 45.8915 1220.36 49.0929C1220.28 45.8915 1220.2 42.6245 1220.14 39.4171ZM1220.23 18.5353C1220.1 20.7116 1220.03 23.2719 1220.01 26.0841L1220.04 23.7394C1220.08 21.8408 1220.14 20.09 1220.23 18.5353ZM1220.63 14.5079C1220.53 15.1768 1220.44 15.9335 1220.37 16.7677L1220.44 15.9601C1220.5 15.4394 1220.56 14.9546 1220.63 14.5089V14.5079ZM1639.92 14.4122C1640.11 14.8459 1640.34 15.2791 1640.6 15.713C1640.34 15.2795 1640.11 14.8465 1639.92 14.4132L1639.92 14.4122ZM1221.06 12.5421C1220.94 12.917 1220.83 13.3615 1220.74 13.8693L1220.86 13.2911C1220.92 13.0177 1220.99 12.7679 1221.06 12.5431V12.5421Z"/></svg>`;

function initLiquid(canvas){
if (canvas.__liquid) return canvas.__liquid;
const hostSel = canvas.getAttribute('data-liquid-host');
const host = (hostSel && document.querySelector(hostSel))
  || canvas.closest('[data-liquid]')
  || canvas.parentElement
  || canvas;
const wordmarkEl = host.querySelector('[data-liquid-carve]');
const wantIntro = canvas.hasAttribute('data-liquid-intro') && !IS_MOBILE;
const tiers = wordmarkEl ? TIERS : (IS_MOBILE ? TIERS_BG : TIERS);
const maxSimSteps = wordmarkEl ? CONFIG.MAX_STEPS : (IS_MOBILE ? 2 : 3);
if (!host.style.touchAction) host.style.touchAction = 'pan-y';
const gl = canvas.getContext('webgl2', {
  antialias:false, alpha:false, depth:false, stencil:false, powerPreference:'low-power',
});
// no WebGL2: the CSS ground colour already stands in, so just leave the page be
if (!gl){ canvas.remove(); return null; }

// half-float when the GPU offers it, RGBA8 otherwise — the field is a single
// 0..1 channel, and the draw pass dithers its lookups to hide 8-bit steps
const hasFloat = !!gl.getExtension('EXT_color_buffer_float');

const VERT = `#version 300 es
void main(){
  vec2 p = vec2((gl_VertexID << 1) & 2, gl_VertexID & 2);
  gl_Position = vec4(p * 2.0 - 1.0, 0.0, 1.0);
}`;

// the engraving, shared by both passes: alpha = groove depth, 0..1
const CARVE = `
uniform sampler2D uCarveTex;
uniform vec4 uCarveRect;   // xy = uv offset (bottom-left), zw = uv size
float carve(vec2 uv){
  vec2 m = (uv - uCarveRect.xy) / uCarveRect.zw;
  if (any(lessThan(m, vec2(0.0))) || any(greaterThan(m, vec2(1.0)))) return 0.0;
  return texture(uCarveTex, m).a;
}
float hash21(vec2 p){ p = fract(p * vec2(123.34, 345.45)); p += dot(p, p + 34.345); return fract(p.x * p.y); }`;

const SIM_FRAG = `#version 300 es
precision highp float;
uniform sampler2D uPrev;   // .r = displacement now, .g = one step ago (biased)
uniform vec2  uRes;
uniform vec2  uBrushA;
uniform vec2  uBrushB;
uniform float uAspect;
uniform float uSpeed;
uniform float uVisc;
uniform float uDamp;
uniform float uPush;
uniform float uRadius;
uniform float uPool;
uniform float uFloor;
uniform float uSmooth;
out vec4 fragColor;
${CARVE}
const float NEUTRAL = 128.0 / 255.0;   // exactly representable in 8 bits
float sdSegment(vec2 p, vec2 a, vec2 b){
  vec2 pa = p - a, ba = b - a;
  float t = clamp(dot(pa, ba) / max(dot(ba, ba), 1e-7), 0.0, 1.0);
  return length(pa - ba * t);
}
void main(){
  vec2 uv = gl_FragCoord.xy / uRes;
  vec2 px = 1.0 / uRes;

  vec2  c    = texture(uPrev, uv).rg;
  float h    = (c.r - NEUTRAL) * 2.0;
  float hOld = (c.g - NEUTRAL) * 2.0;

  // Both history channels off the same four fetches — .r for the wave term,
  // .g so we can also difference the VELOCITY field. Free: same samples.
  vec2 ns = texture(uPrev, uv + vec2(px.x, 0.0)).rg + texture(uPrev, uv - vec2(px.x, 0.0)).rg
          + texture(uPrev, uv + vec2(0.0, px.y)).rg + texture(uPrev, uv - vec2(0.0, px.y)).rg;
  vec2 nd = ns * 2.0 - 8.0 * NEUTRAL;      // decoded neighbour sums: .x = h, .y = hOld

  float v    = h - hOld;                   // surface velocity, per step
  float lapH = nd.x - 4.0 * h;             // restoring force
  float lapV = (nd.x - nd.y) - 4.0 * v;    // viscous term: laplacian of velocity

  /* This is what separates syrup from water. A flat uDamp multiplier decays
     every spatial frequency at the same rate, so fine chatter rings exactly as
     long as a broad swell — the giveaway that a surface is thin. Real viscosity
     dissipates in proportion to the velocity GRADIENT, so damping scales with
     k^2: the checkerboard mode dies at ~0.7 per step while a broad swell sits
     at ~0.999. That lets uDamp be raised (the material now holds an
     impression for seconds) without the surface ever ringing.
     uVisc must stay under 1/8 — at that point the hOld coefficient flips sign
     and the highest mode goes unstable. */
  float hNew = (h + v + lapH * uSpeed + lapV * uVisc) * uDamp;

  // Grid-scale low pass, belt-and-braces for the 8-bit path where rounding
  // error is spatially white and would otherwise pump the checkerboard mode.
  // Mostly redundant now that uVisc damps by k^2, so it is kept small.
  hNew = mix(hNew, nd.x * 0.25, uSmooth);

  if (uPush > 0.0){
    vec2 p = vec2(uv.x * uAspect, uv.y);
    float d = sdSegment(p, vec2(uBrushA.x * uAspect, uBrushA.y),
                           vec2(uBrushB.x * uAspect, uBrushB.y));
    // press the surface DOWN under the cursor; the rings that spread out from
    // it are the wave solving itself, not anything drawn
    hNew -= smoothstep(uRadius, 0.0, d) * uPush * (1.0 + uPool * carve(uv));
  }

  // let the surface actually reach rest instead of limit-cycling on the LSB
  if (abs(hNew) < uFloor && abs(h) < uFloor) hNew = 0.0;

  hNew = clamp(hNew, -0.99, 0.99);
  fragColor = vec4(hNew * 0.5 + NEUTRAL, c.r, 0.0, 1.0);
}`;

const DRAW_FRAG = `#version 300 es
precision highp float;
uniform sampler2D uHeight;
uniform vec2  uRes;
uniform vec2  uStep;
uniform vec2  uCarveStep;
uniform vec3  uBgDeep;
uniform vec3  uBgLit;
uniform vec3  uLight;
uniform float uAmp;
uniform float uCarve;
uniform float uNStr;
uniform float uContrast;
uniform float uGloss;
uniform float uJitter;
out vec4 fragColor;
${CARVE}
// ONE surface, but its two marks live at very different scales, so their slopes
// are read at different steps. The wave is a coarse simulation grid; the
// engraving is a static supersampled texture whose bevel is far finer than one
// sim texel. Sampling the carve on the wave's grid — which is what it used to
// do — averaged the bevel away and left the letters looking like flat outlines.
float wave(vec2 uv){ return (texture(uHeight, uv).r - 128.0 / 255.0) * 2.0; }
void main(){
  vec2 uv = gl_FragCoord.xy / uRes;
  vec2 pw = uStep;        // one sim texel
  vec2 pc = uCarveStep;   // one screen pixel

  // On an 8-bit height buffer the quantization steps show up as terraces once
  // uNStr amplifies the gradient. Offsetting the wave lookups by a fixed
  // sub-texel amount per pixel breaks the plateaus up without disturbing the
  // derivative — and being a hash of fragCoord, it never shimmers. The carve is
  // sampled unjittered so the letterforms keep clean edges.
  vec2 j = (vec2(hash21(gl_FragCoord.xy), hash21(gl_FragCoord.yx + 7.3)) - 0.5) * pw * uJitter;
  vec2 s = uv + j;

  float w   = wave(s);
  float wx1 = wave(s + vec2(pw.x, 0.0)), wx0 = wave(s - vec2(pw.x, 0.0));
  float wy1 = wave(s + vec2(0.0, pw.y)), wy0 = wave(s - vec2(0.0, pw.y));

  float c   = carve(uv);
  float cx1 = carve(uv + vec2(pc.x, 0.0)), cx0 = carve(uv - vec2(pc.x, 0.0));
  float cy1 = carve(uv + vec2(0.0, pc.y)), cy0 = carve(uv - vec2(0.0, pc.y));

  // rescale the carve slope into the wave's units so one uNStr governs both
  float k = pw.x / pc.x;
  float h  = w * uAmp - c * uCarve;
  float gx = (wx1 - wx0) * uAmp - (cx1 - cx0) * uCarve * k;
  float gy = (wy1 - wy0) * uAmp - (cy1 - cy0) * uCarve * k;

  vec3 n = normalize(vec3(-gx * uNStr, -gy * uNStr, 1.0));
  vec3 l = normalize(uLight);

  // wide soft glow toward the top, per the hero's background ellipse
  float g = length((uv - vec2(0.5, 0.78)) * vec2(uRes.x / uRes.y * 0.5, 1.0));
  vec3 base = mix(uBgLit, uBgDeep, smoothstep(0.05, 0.9, g));

  // shade RELATIVE to a flat surface, so untouched ground lands exactly on the
  // base colour — the relief only ever reads as light, never as a colour shift
  float shade = 1.0 + (dot(n, l) - l.z) * uContrast;
  vec3 col = base * max(shade, 0.22);

  // tempered-chocolate gloss, gated on a steep slope so only the bead's
  // shoulders and the groove walls catch a highlight
  vec3 hv = normalize(l + vec3(0.0, 0.0, 1.0));
  float slope = smoothstep(0.03, 0.22, 1.0 - n.z);
  col += vec3(1.0, 0.86, 0.72) * pow(max(dot(n, hv), 0.0), 60.0) * uGloss * slope;

  // curvature stands in for occlusion: the inside of the groove darkens, crests
  // catch light. This is what makes the carving read as depth rather than paint.
  // Second derivative, so the carve's rescale is k squared.
  float lap = ((wx1 + wx0 + wy1 + wy0) - 4.0 * w) * uAmp
            - ((cx1 + cx0 + cy1 + cy0) - 4.0 * c) * uCarve * k * k;
  col *= 1.0 - clamp( lap * 9.0, 0.0, 1.0) * 0.18;
  col *= 1.0 + clamp(-lap * 9.0, 0.0, 1.0) * 0.07;

  col += (hash21(gl_FragCoord.xy) - 0.5) * 0.016; // grain
  fragColor = vec4(col, 1.0);
}`;

// ---------- GL plumbing ----------
function compile(type, src){
  const s = gl.createShader(type);
  gl.shaderSource(s, src); gl.compileShader(s);
  if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(s));
  return s;
}
function program(fragSrc){
  const p = gl.createProgram();
  gl.attachShader(p, compile(gl.VERTEX_SHADER, VERT));
  gl.attachShader(p, compile(gl.FRAGMENT_SHADER, fragSrc));
  gl.linkProgram(p);
  if (!gl.getProgramParameter(p, gl.LINK_STATUS)) throw new Error(gl.getProgramInfoLog(p));
  return p;
}
// cache uniform locations once — getUniformLocation per frame is a real cost
function uniforms(prog, names){
  const u = {};
  for (const n of names) u[n] = gl.getUniformLocation(prog, n);
  return u;
}

const simProg = program(SIM_FRAG);
const drawProg = program(DRAW_FRAG);
const SU = uniforms(simProg, ['uPrev','uCarveTex','uCarveRect','uRes','uBrushA','uBrushB',
  'uAspect','uSpeed','uVisc','uDamp','uPush','uRadius','uPool','uFloor','uSmooth']);
const DU = uniforms(drawProg, ['uHeight','uCarveTex','uCarveRect','uRes','uStep','uBgDeep',
  'uBgLit','uLight','uAmp','uCarve','uCarveStep','uNStr','uContrast','uGloss','uJitter']);
const vao = gl.createVertexArray();

function texParams(){
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
}

let simW = 0, simH = 0, texA, texB, fbA, fbB;
let curTex, curFb, altTex, altFb;   // which half of the ping-pong holds "now"
function makeTarget(w, h){
  const t = gl.createTexture();
  gl.bindTexture(gl.TEXTURE_2D, t);
  if (hasFloat) gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA16F, w, h, 0, gl.RGBA, gl.HALF_FLOAT, null);
  else          gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA8,  w, h, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
  texParams();
  const f = gl.createFramebuffer();
  gl.bindFramebuffer(gl.FRAMEBUFFER, f);
  gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, t, 0);
  // flat surface == the storage bias, and 128/255 exactly (not 0.5 == 127.5)
  gl.clearColor(128/255, 128/255, 0, 1); gl.clear(gl.COLOR_BUFFER_BIT);
  return [t, f];
}

// ---------- the engraving ----------
// Rasterised from the SVG at whatever box the CSS gives .wordmark, so the
// carving tracks the layout (including the mobile breakpoint) for free.
let carveTex = gl.createTexture();
gl.bindTexture(gl.TEXTURE_2D, carveTex);
gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, new Uint8Array([0,0,0,0]));
texParams();
let carveRect = [0, 0, 1, 1];
let carveReady = false;

const svgImage = new Image();

function buildCarve(){
  if (!wordmarkEl) return;
  if (!svgImage.complete || !svgImage.naturalWidth) return;
  const r = wordmarkEl.getBoundingClientRect();
  const hr = canvas.getBoundingClientRect();
  if (!r.width || !r.height || !hr.width || !hr.height) return;

  // Rasterise above display resolution, capped by what the GPU will hold. The
  // bevel is a fraction of cap height, so at 1x this serif's hairlines would
  // land under a single texel and the emboss would wash out — exactly the
  // failure that made it look flat at 100% zoom and rich when zoomed out.
  const ssCap = Math.min(gl.getParameter(gl.MAX_TEXTURE_SIZE), 6144);
  const ss = Math.min(tiers[quality].carve * (canvas.width / hr.width),
                      (ssCap - 16) / r.width);

  const gw = Math.max(1, Math.round(r.width  * ss));
  const gh = Math.max(1, Math.round(r.height * ss));
  const blur = CONFIG.CARVE_BEVEL * gh;        // proportional => zoom-invariant
  const pad = Math.ceil(blur * 3);

  const c = document.createElement('canvas');
  c.width  = gw + pad * 2;
  c.height = gh + pad * 2;
  const ctx = c.getContext('2d');
  ctx.filter = `blur(${blur}px)`;
  if (ctx.filter === 'none'){
    // Safari < 17 has no canvas filter: stack offset draws for a usable falloff
    ctx.globalAlpha = 0.16;
    for (let k = 0; k < 8; k++){
      const a = 6.2831853 * k / 8;
      ctx.drawImage(svgImage, pad + Math.cos(a) * blur * 0.7,
                              pad + Math.sin(a) * blur * 0.7, gw, gh);
    }
    ctx.globalAlpha = 1;
  } else {
    ctx.drawImage(svgImage, pad, pad, gw, gh);
    ctx.filter = 'none';
  }

  gl.bindTexture(gl.TEXTURE_2D, carveTex);
  gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true); // canvas y-down -> GL uv y-up
  gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, c);
  gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
  texParams();

  const padCss = pad / ss;   // pad is in raster px; the rect is in CSS space
  carveRect = [
    (r.left - hr.left - padCss) / hr.width,
    1 - (r.bottom - hr.top + padCss) / hr.height,
    (r.width  + padCss * 2) / hr.width,
    (r.height + padCss * 2) / hr.height,
  ];
  carveReady = true;
}

svgImage.onload = () => buildCarve();
if (wordmarkEl){
  svgImage.src = URL.createObjectURL(new Blob([COLIBRI_SVG], { type: 'image/svg+xml' }));
}

// ---------- sizing ----------
let quality = wordmarkEl ? 1 : (IS_MOBILE ? 0 : 1), aspect = 1;
function resize(){
  const tier = tiers[quality];
  const w = canvas.clientWidth || 1, h = canvas.clientHeight || 1;
  aspect = w / h;
  canvas.width  = Math.round(w * tier.dpr);
  canvas.height = Math.round(h * tier.dpr);
  simW = Math.max(2, Math.round(canvas.width  * tier.sim));
  simH = Math.max(2, Math.round(canvas.height * tier.sim));
  [texA, fbA] = makeTarget(simW, simH);
  [texB, fbB] = makeTarget(simW, simH);
  curTex = texA; curFb = fbA; altTex = texB; altFb = fbB;
  buildCarve();
}
window.addEventListener('resize', resize);
if (typeof ResizeObserver !== 'undefined'){
  new ResizeObserver(resize).observe(host);
}
resize();

/* ---------- viscosity ----------
   Positions live in screen space: y spans 0..1, x spans 0..aspect, so the
   physics is isotropic. The bead is an overdamped spring chasing the cursor
   with a hard ceiling on speed — that ceiling is what sells "thick liquid":
   flick the pointer and the bead simply cannot keep up, it crawls after you. */
const pointer = { x: 0.5, y: 0.5, active: false, lastMove: -1e9 };
const bead = { x: 0.5, y: 0.5, vx: 0, vy: 0, strength: 0, speed: 0 };

function setPointer(e){
  const r = canvas.getBoundingClientRect();
  pointer.x = (e.clientX - r.left) / r.height;
  pointer.y = 1.0 - (e.clientY - r.top) / r.height;
  pointer.active = true;
  pointer.lastMove = performance.now();
}
function clearPointer(){ pointer.active = false; }
host.addEventListener('pointerdown', (e) => {
  setPointer(e);
});
host.addEventListener('pointermove', setPointer, { passive: true });
host.addEventListener('pointerup', clearPointer);
host.addEventListener('pointercancel', clearPointer);
host.addEventListener('pointerleave', clearPointer);
host.addEventListener('touchmove', (e) => {
  const t = e.touches[0];
  if (t) setPointer(t);
}, { passive: true });

function integrate(tx, ty, dt){
  // substep so the spring stays stable when frames get long
  const steps = Math.min(4, Math.max(1, Math.ceil(dt / 0.017)));
  const sdt = dt / steps;
  for (let i = 0; i < steps; i++){
    bead.vx += ((tx - bead.x) * CONFIG.STIFFNESS - bead.vx * CONFIG.DRAG) * sdt;
    bead.vy += ((ty - bead.y) * CONFIG.STIFFNESS - bead.vy * CONFIG.DRAG) * sdt;
    const sp = Math.hypot(bead.vx, bead.vy);
    if (sp > CONFIG.MAX_SPEED){
      const k = CONFIG.MAX_SPEED / sp;
      bead.vx *= k; bead.vy *= k;
    }
    bead.x += bead.vx * sdt;
    bead.y += bead.vy * sdt;
  }
  bead.speed = Math.hypot(bead.vx, bead.vy);
}

// ---------- intro ----------
const INTRO_MS = 3200;
const t0 = performance.now();
const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function introTarget(t){ // a slow sweep across the open left of the composition
  const k = Math.min(t / INTRO_MS, 1);
  const e = k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
  return {
    x: aspect * (0.16 + 0.42 * e),
    y: 0.34 + 0.30 * Math.sin(e * Math.PI * 1.6),
  };
}

// ---------- loop ----------
const STEP = 1 / 120;                // the wave is solved at a fixed rate
let simAcc = 0;
const stamp = { x: 0.5, y: 0.5 };    // cursor position at the last solved step
let last = performance.now();
let probeAcc = 0, probeN = 0;
let rafId = 0, running = false;
function frame(now){
  if (!running) return;
  const rawDt = Math.min((now - last) / 1000, 2.0); // wall clock, survives throttling
  const dt = Math.min(rawDt, 0.05); last = now;
  const t = now - t0;

  // one-way quality drop if the machine can't hold ~40fps.
  // Skip this on a carved wordmark: sim is part of the lighting scale, so a
  // mid-session drop would darken the letters.
  if (!wordmarkEl && quality > 0 && t > 1500){
    probeAcc += rawDt; probeN++;
    if (probeN >= 90){
      if (probeAcc / probeN > 0.026){ quality = 0; resize(); }
      probeAcc = 0; probeN = 0;
    }
  }

  let target = null, gain = 1;
  if (pointer.active && now - pointer.lastMove < 400) target = pointer;
  else if (wantIntro && !reduced && t < INTRO_MS && !pointer.active){
    target = introTarget(t);
    gain = 0.7;   // the unattended intro lays down a lighter trail than a real stroke
  }

  if (target) integrate(target.x, target.y, dt);
  else        integrate(bead.x, bead.y, dt);   // coast to a stop
  bead.strength += ((target ? 1 : 0) - bead.strength) * (1 - Math.pow(0.05, dt));

  // slow => a broad soft dimple; fast => a narrower one that rakes the surface
  const sn = Math.min(bead.speed / CONFIG.MAX_SPEED, 1);
  const radius = CONFIG.RADIUS * (1.25 - 0.40 * sn);

  gl.bindVertexArray(vao);

  // --- wave, stepped at a fixed rate so ripple speed is display-independent ---
  simAcc += rawDt;
  if (simAcc > STEP * (maxSimSteps + 2)) simAcc = STEP;
  let steps = 0;
  while (simAcc >= STEP && steps < maxSimSteps){
    simAcc -= STEP; steps++;

    gl.bindFramebuffer(gl.FRAMEBUFFER, altFb);
    gl.viewport(0, 0, simW, simH);
    gl.useProgram(simProg);
    gl.activeTexture(gl.TEXTURE0); gl.bindTexture(gl.TEXTURE_2D, curTex);
    gl.activeTexture(gl.TEXTURE1); gl.bindTexture(gl.TEXTURE_2D, carveTex);
    gl.uniform1i(SU.uPrev, 0);
    gl.uniform1i(SU.uCarveTex, 1);
    gl.uniform4fv(SU.uCarveRect, carveRect);
    gl.uniform2f(SU.uRes, simW, simH);
    // the press spans from wherever the cursor was at the last solved step, so
    // a display running ahead of the solver still leaves no gaps
    gl.uniform2f(SU.uBrushA, stamp.x / aspect, stamp.y);
    gl.uniform2f(SU.uBrushB, bead.x  / aspect, bead.y);
    gl.uniform1f(SU.uAspect, aspect);
    gl.uniform1f(SU.uSpeed, CONFIG.SPEED);
    gl.uniform1f(SU.uVisc,  CONFIG.VISC);
    gl.uniform1f(SU.uDamp, CONFIG.DAMP);
    gl.uniform1f(SU.uPush, CONFIG.PUSH * bead.strength * gain);
    gl.uniform1f(SU.uRadius, radius);
    gl.uniform1f(SU.uPool, carveReady ? CONFIG.POOL : 0.0);
    gl.uniform1f(SU.uFloor,  hasFloat ? 0.0 : 0.02);
    gl.uniform1f(SU.uSmooth, hasFloat ? 0.0 : 0.02);
    gl.drawArrays(gl.TRIANGLES, 0, 3);

    const tt = curTex, tf = curFb;
    curTex = altTex; curFb = altFb;
    altTex = tt;     altFb = tf;
    stamp.x = bead.x; stamp.y = bead.y;
  }

  // --- draw ---
  gl.bindFramebuffer(gl.FRAMEBUFFER, null);
  gl.viewport(0, 0, canvas.width, canvas.height);
  gl.useProgram(drawProg);
  gl.activeTexture(gl.TEXTURE0); gl.bindTexture(gl.TEXTURE_2D, curTex);
  gl.activeTexture(gl.TEXTURE1); gl.bindTexture(gl.TEXTURE_2D, carveTex);
  gl.uniform1i(DU.uHeight, 0);
  gl.uniform1i(DU.uCarveTex, 1);
  gl.uniform4fv(DU.uCarveRect, carveRect);
  gl.uniform2f(DU.uRes, canvas.width, canvas.height);
  gl.uniform2f(DU.uStep, 1 / simW, 1 / simH);
  // one screen pixel — the engraving's bevel is finer than a sim texel
  gl.uniform2f(DU.uCarveStep, 1 / canvas.width, 1 / canvas.height);
  gl.uniform3fv(DU.uBgDeep, CONFIG.BG_DEEP);
  gl.uniform3fv(DU.uBgLit, CONFIG.BG_LIT);
  gl.uniform3fv(DU.uLight, CONFIG.LIGHT_DIR);
  gl.uniform1f(DU.uAmp, CONFIG.AMPLITUDE);
  gl.uniform1f(DU.uCarve, carveReady ? CONFIG.CARVE : 0.0);
  gl.uniform1f(DU.uNStr, CONFIG.NORMAL);
  gl.uniform1f(DU.uContrast, CONFIG.CONTRAST);
  gl.uniform1f(DU.uGloss, CONFIG.GLOSS);
  gl.uniform1f(DU.uJitter, hasFloat ? 0.0 : 1.0);
  gl.drawArrays(gl.TRIANGLES, 0, 3);

  if (running) rafId = requestAnimationFrame(frame);
}

function start(){
  if (running) return;
  running = true;
  last = performance.now();
  rafId = requestAnimationFrame(frame);
}
function stop(){
  running = false;
  pointer.active = false;
  cancelAnimationFrame(rafId);
  rafId = 0;
}

let inView = false;
function pageVisible(){ return document.visibilityState !== 'hidden'; }
function syncPlayback(){ inView && pageVisible() ? start() : stop(); }
new IntersectionObserver(([e]) => {
  inView = e.isIntersecting;
  syncPlayback();
}, { threshold: 0 }).observe(host);
document.addEventListener('visibilitychange', syncPlayback);

const api = { start, stop };
canvas.__liquid = api;
return api;
}

function watchCanvas(canvas){
  if (canvas.__liquid || canvas.__liquidWatch) return;
  canvas.__liquidWatch = true;
  if (typeof IntersectionObserver === 'undefined'){
    initLiquid(canvas);
    return;
  }
  const io = new IntersectionObserver((entries) => {
    const e = entries[entries.length - 1];
    if (e && e.isIntersecting){
      io.disconnect();
      initLiquid(canvas);
    }
  }, { rootMargin: '80px', threshold: 0 });
  io.observe(canvas);
}

// function bootLiquid(root){
//   (root || document).querySelectorAll('canvas[data-liquid-bg]').forEach(watchCanvas);
// }

// if (document.readyState === 'loading'){
//   document.addEventListener('DOMContentLoaded', () => bootLiquid());
// } else {
//   bootLiquid();
// }

window.addEventListener('load', () => {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      document.querySelectorAll('[data-liquid-bg]').forEach(initLiquid);
    });
  });
});